import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MetaTags from 'react-meta-tags';
import * as gigActions from '../../actions/gigActions';
import settings from '../../constants/settings.js';
import PageLoading from '../common/PageLoading';
import NotFound from '../common/NotFound';
import Error from '../common/Error';

class GigDetailsPage extends Component {
    constructor(props, context) {
        super(props, context);
        this.getNoGigComponent = this.getNoGigComponent.bind(this);
        this.getGigArtist = this.getGigArtist.bind(this);
        this.getGigArtists = this.getGigArtists.bind(this);
    }  
    componentWillMount() {
        this.props.actions.getGig(this.props.match.params.id);
    }

    getGigArtists() {
        const artistLinks = [];
        const artistDetails = [];
        const artists = this.props.gig.Artists;
        for (let username in artists) {
            if (artists.hasOwnProperty(username)) 
            {
                const displayName = artists[username];
                artistDetails.push([username, displayName]);                
            }
        }
        for(let i = 0; i < artistDetails.length; i++) {
            artistLinks.push(this.getGigArtist(artistDetails[i][0], artistDetails[i][1], i, artistDetails.length));
        }
        return artistLinks;
    }

    getGigArtist(username, displayName, index, count) {
        let separator = index < count - 1 ? ', ':'';
        return (<span key={username}>
                <Link className="transition" to={`/${username}`}>{displayName}</Link>
                <span>{separator}</span>
            </span>);
    }

    getNoGigComponent() {
        if(this.props.gigLoadingStatus == 'LOADING') {
            return <PageLoading />;
        }
        /*else if(this.props.gigLoadingStatus == 'FAILED') {
            return <Error />;
        }*/
        else {
            return <NotFound />;
        }
    }

    render() {
        const gig = this.props.gig;
        const startDate = gig ? new Date(gig.StartDate) : null;
        const endDate = gig ? new Date(gig.EndDate) : null;
        const startDateFormatted = gig ? startDate.toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' }) : '';
        const startDateTimeFormatted = gig ? `${startDate.toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' })} ${startDate.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}` : '';
        const endDateTimeFormatted = gig ? `${endDate.toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' })} ${endDate.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}` : '';        let artistIndex = 0;
        const key = settings.GOOGLEPLACES_KEY;
        return (
            gig ? 
                <div>
                    <MetaTags>
                        <title>{`Gig - ${gig.EventName} (${startDateFormatted}) - LoudUp`}</title>
                        <meta id="description" name="description" content={`Get full details for gig '${gig.EventName}' on ${startDateFormatted}. Find out everything from the start time, price, and location details.`} />
                    </MetaTags>
                    <div className="main">
                        <div className="container">
                            <div className="block-inner">
                                <div className="row">
                                    <div className="col-md-12">
                                        <article className="body-copy">
                                            <header>
                                                <h1 className="section-alt">{gig.EventName}</h1>
                                            </header>
                                            <div className="col-sm-12">
                                                <p>
                                                    <span style={{fontWeight: 'bold'}}>Artists: </span>
                                                    {this.getGigArtists()}                                                                                                    
                                                </p>
                                                <p className="search-res">
                                                    <span style={{fontWeight: 'bold'}}>Genres: </span>
                                                    {gig.Genres.map((genre) =>  
                                                         <Link key={genre} to="#" className="badge transition" style={{marginRight: '1px'}}>{genre}</Link>
                                                    )}
                                                </p>
                                                <p>
                                                    <span style={{fontWeight: 'bold'}}>Start Date:</span> {startDateTimeFormatted}
                                                </p>
                                                {gig.EndDate ?
                                                    <p>
                                                        <span style={{fontWeight: 'bold'}}>End Date:</span> {endDateTimeFormatted}
                                                    </p> : null
                                                }                                                
                                                {
                                                    gig.Description ?
                                                    <p>
                                                        <span style={{fontWeight: 'bold'}}>Description:</span> {gig.Description}
                                                    </p> : null
                                                }
                                                <p>
                                                    <span style={{fontWeight: 'bold'}}>Location:</span> {gig.Location}
                                                </p>
                                                <p>
                                                    <span style={{fontWeight: 'bold'}}>Venue:</span> {gig.Venue}
                                                </p>
                                                <p>
                                                    <span style={{fontWeight: 'bold'}}>Address:</span> {gig.Address}
                                                </p>
                                                <p>
                                                    <span style={{fontWeight: 'bold'}}>Ticket Price:</span> {gig.TicketPrice}
                                                </p>
                                                {gig.TicketSaleLink ?
                                                
                                                    <p>
                                                        <span style={{fontWeight: 'bold'}}>Ticket Sales:</span> <a href={gig.TicketSaleLink} target="_blank" rel="nofollow">{gig.TicketSaleLink}</a>
                                                    </p> : null
                                                }
                                                <p>
                                                    <br />
                                                    <div className="embed-container">
                                                        <iframe width="520" height="400" style={{border: 'solid 1px #aaa'}} src={`https://www.google.com/maps/embed/v1/place?q=${encodeURIComponent(gig.Venue)}&zoom=16&key=${key}`} />    
                                                    </div>
                                                </p>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div>
            : this.getNoGigComponent()
        );
    }
}

GigDetailsPage.propTypes = {
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    gig: PropTypes.object,
    gigLoadingStatus: PropTypes.string.isRequired
};

function mapStateToProps(state, ownProps) {
    let gig;
    if(state.gigs.gig && state.gigs.gig.ID == ownProps.match.params.id) {
        gig = state.gigs.gig;
    }
    const gigLoadingStatus = state.gigs.gigLoadingStatus;
    return { 
        gig,
        gigLoadingStatus
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //account actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, gigActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GigDetailsPage);
